import React from 'react';
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
const TermsOfUse = () => {
    return (
        <div className="bg-offWhite p-0">
            <NavBar/>
            <div style={{paddingTop:"12rem"}}>
                <div className="d-flex justify-content-center" style={{ backgroundColor: "#A6CE3A" }}>
                    <h2 className="text-white fw-bold pt-5 pb-4">TERMS OF USE</h2>
                </div>
                <Footer/>
            </div>
        </div>
    )
}
export default TermsOfUse;